import classNames from 'clsx';
import React from 'react';

import { Icon } from '@swf/sports/components';
import SportsFormattedTimeZone from '@swf/sports/components/SportsFormattedTimeZone/SportsFormattedTimeZone';

import styles from './EventTitle.scss';

interface Props {
  eventName: string;
  eventStartTime: string;
  isOpen?: boolean;
}

const EventTitle: React.FC<Props> = ({ eventName, eventStartTime, isOpen = false }) => (
  <div className={styles.sgmEventWrapper}>
    <div className={styles.sgmEventInfo}>
      <span className={styles.sgmEvent}>{eventName || ''}</span>
      <SportsFormattedTimeZone date={eventStartTime || ''} format="medium" withTime />
    </div>

    <Icon
      name="chevron-medium-down"
      className={classNames(styles.icon, { [styles.iconOpen]: isOpen })}
      size="lg"
    />
  </div>
);

export default EventTitle;
